export function formatNumberWithLocale(number: number | string, locale: string): string {
  const numericValue = Number(number)
  if (isNaN(numericValue)) {
    return ""
  }
  return new Intl.NumberFormat(locale).format(numericValue)
}
